import { render, staticRenderFns } from "./memberDetail.vue?vue&type=template&id=083dd0b6&scoped=true&"
import script from "./memberDetail.vue?vue&type=script&lang=ts&"
export * from "./memberDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dd0b6",
  null
  
)

export default component.exports